import { border } from 'polished';

const borderStyles = ['1px', 'solid'] as const;

export const defaultBorder = border(...borderStyles);
export const defaultBorderTop = border('top', ...borderStyles);
export const defaultBorderRight = border('right', ...borderStyles);
export const defaultBorderBottom = border('bottom', ...borderStyles);
export const defaultBorderLeft = border('left', ...borderStyles);
